var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-0 my-0 px-5 py-5 content-description"},[_c('p-rich-text',{attrs:{"canEdit":_vm.canEdit},model:{value:(_vm.value.body.contents.description),callback:function ($$v) {_vm.$set(_vm.value.body.contents, "description", $$v)},expression:"value.body.contents.description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }